import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../core/services/apiHelper';
import { environment } from '../../../environments/environment';
import { UserDAO } from '../../../core/services/dao/userDAO';
import { User } from 'anchor-shared/lib/model/entity/user';

@Injectable()
export class ProfileResolve implements Resolve<any> {
  user: User;

  constructor(
    private authService: AuthService,
    private apiHelper: ApiHelper,
    private readonly userDAO: UserDAO,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    this.user = this.userDAO.getCurrentUser();

    const userResolve = this.userDAO.loadById(this.user.id);
    const sessionResolve = this.authService.checkSession();
    return combineLatest([userResolve, sessionResolve]).pipe(
      map(([userResolve, sessionResolve]) => ({ userResolve, sessionResolve })),
      take(1),
    );
  }
}
